<ion-content>
  <form [formGroup]="form">
    <ion-list>
      <ion-item>
        <ion-select label="{{'Round Number (Col)' | translate}}" labelPlacement="stacked" formControlName="roundNumber" interface="popover">
            <ion-select-option [value]="1">1</ion-select-option>
            <ion-select-option [value]="2">2</ion-select-option>
            <ion-select-option [value]="3">3</ion-select-option>
        </ion-select>
      </ion-item>
      
      <ion-item>
        <ion-select label="{{'Round Position (Row)' | translate}}" labelPlacement="stacked" formControlName="roundPosition" interface="popover">
            <ion-select-option [value]="1">1</ion-select-option>
            <ion-select-option [value]="2">2</ion-select-option>
            <ion-select-option [value]="3">3</ion-select-option>
            <ion-select-option [value]="4">4</ion-select-option>
        </ion-select>
      </ion-item>      
    </ion-list>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button (click)="submit()" expand="block" fill="clear" shape="round">
      {{'Submit' | translate}}
    </ion-button>  
  </ion-toolbar>
</ion-footer>